import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchSyncErrors } from "src/Pages/Company/OrganizationStructure/api";
import { UseFetchSyncErrorsParams } from "src/Pages/Company/EmployeeManagement/SyncErrors/models/syncErrors.models";

export const useFetchSyncErrors = ({
  companyId,
  page,
  size,
  sort,
  filters,
}: UseFetchSyncErrorsParams) =>
  useQuery({
    enabled: !!companyId,
    queryKey: ["sync-errors", companyId, page, size, sort, filters],
    queryFn: () =>
      fetchSyncErrors({ companyId, page, size, sort, filters }),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
